import { Element } from "@xmpp/xml"

export type DriverPolyline = {
  polyline: string
  distance: number
}

export default class DriverPolylineParser {
  static parse(stanza: Element): DriverPolyline | undefined {
    if (
      stanza.name !== "iq" ||
      !stanza.getAttr("from") ||
      !stanza.getAttr("to")
    )
      return

    const command = stanza.getChild(
      "command",
      "http://jabber.org/protocol/commands",
    )
    if (!command) return

    const json = command.getChild("json", "urn:xmpp:json:0")
    if (!json) return
    let polylineAndDistance
    try {
      polylineAndDistance = JSON.parse(json!.text())
    } catch {
      console.log("Invalid JSON format in DriverPolyline")
    }

    return {
      polyline: polylineAndDistance.polyline,
      distance: polylineAndDistance.distance,
    }
  }
}
